export const loginSuccess = {
    event: "login",
    eventCategory: "login",
    eventAction: "login_popup",
    eventLabel: "login"
};
